import { render, staticRenderFns } from "./ActivityContent.vue?vue&type=template&id=606aa0a3&scoped=true&"
import script from "./ActivityContent.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivityContent.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ActivityContent.vue?vue&type=style&index=0&id=606aa0a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606aa0a3",
  null
  
)

export default component.exports